import { registerFigure } from "./base.js";
/**
 * One thing in the middle, others going round it.
 *
 * The first kind where the movement is the answer rather than a way of reading
 * the picture. "Why does the Moon go round the Earth", "what is a year on
 * Mars", "why does it take longer the further out you go" — a still diagram of
 * circles makes a child take the going-round on trust, and going round is the
 * entire content.
 *
 * Deliberately carries no numbers. `scale` already exists for "how much bigger
 * is it", and asking for orbital distances invites a model to invent them:
 * order alone says which is nearer, and order is what a child needs.
 */
export const orbitFigure = registerFigure({
    kind: "orbit",
    summary: "One body in the middle, others circling it in order.",
    chooseWhen: "Something goes round something else and the going round is the point — " +
        "the Moon and the Earth, the planets and the Sun, a satellite. The FIRST " +
        "label is what sits in the middle; the rest orbit it, nearest first. Do " +
        "not use it for things that merely spin, or for how big things are.",
    issues(figure) {
        const labels = figure.labels ?? [];
        if (labels.length < 2)
            return ["An orbit needs something in the middle and something going round it."];
        // Four rings is already a busy picture at the size a figure gets, and the
        // outermost has to stay inside the frame.
        if (labels.length > 5)
            return ["More than 4 things in orbit stops being a picture."];
        if (labels.some((l) => l.trim().length === 0))
            return ["A body cannot be blank."];
        return [];
    },
    normalise(figure) {
        return {
            kind: "orbit",
            caption: figure.caption,
            labels: (figure.labels ?? []).map((l) => l.trim()),
        };
    },
    example: {
        kind: "orbit",
        caption: "The further out a planet is, the longer its year.",
        labels: ["Sun", "Mercury", "Earth", "Mars"],
    },
});
//# sourceMappingURL=orbit.js.map